unit Heslo;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.Buttons, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.REST, WEBLib.CDS, Data.DB, WEBLib.FlexControls,
  WEBLib.ExtCtrls, WEBLib.JSON, System.NetEncoding;

type TPRISTPRAV = array[0..1000] of integer;

type
  TfHeslo = class(TForm)
    [async]
    WebClientConnection1: TClientConnection;
    QUser: TClientDataSet;
    QUserKarta: TStringField;
    QUserMeno: TStringField;
    QUserPriezvisko: TStringField;
    WebPanel1: TPanel;
    eLogin: TEdit;
    sbEnter: TSpeedButton;
    ePass: TEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    QUserUZIV_ROLA: TIntegerField;

    procedure WebFormCreate(Sender: TObject);
    [async]
    procedure sbEnterClick(Sender: TObject); async;
    procedure WebFormShow(Sender: TObject);
    procedure eLoginKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure ePassKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);

  private
    { Private declarations }
  public
    { Public declarations }
    sWord,sEnc,eFileIP,eOpenFileIP: string;
    ascii : LongInt;
    CurrentForm: TForm;
    CurrentFormElement: String;
    CurrentFormSource: String;
    UId: integer;
      URolaPopis, UMeno,UPriezvisko : String;
       MojaServerIP: string;
  protected procedure LoadDFMValues; override; end;

const SCode = '750502';

var
  fHeslo: TfHeslo;
  PRISTPRAV: TPRISTPRAV;
  URola : Integer;

implementation

{$R *.dfm}

uses Hlavny;


procedure TfHeslo.WebFormCreate(Sender: TObject);
begin
//MojaServerIP := 'http://' + window.location.hostname + ':8080/';
//MojaServerIP := '/api';
 MojaServerIP := window.location.hostname;


  asm
    window.sleep = async function(msecs) {return new Promise((resolve) => setTimeout(resolve, msecs)); }
  end;

end;

procedure TfHeslo.WebFormShow(Sender: TObject);
begin
ELOGIN.SetFocus;
end;

procedure TfHeslo.eLoginKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
if key = 13 then
ePass.SetFocus;
end;

procedure TfHeslo.ePassKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
if key = 13 then
sbEnterClick(Self);
end;

procedure TfHeslo.sbEnterClick(Sender: TObject);
var
  Hlavny: TfHlavny;
  iCount, iMove, i, x: integer;
  d: double;
  rest1: boolean;
  JS: TJSON;
  JA: TJSONArray;
  JO: TJSONObject;
  wr: THttpRequest;
  res: TJSXMLHttpRequest;
  jsonO: TJSONObject;
  jsonA: TJSONArray;
  JsonValue :TJsonValue;
  ArrayElement: TJSonValue;
  FoundValue: TJSonValue;
  a : string;
begin


  uid := 0;
  wr := THttpRequest.Create(nil);
  wr.Command := httpPOST;
  // OPRAVA 1: MojaServerIP už obsahuje 'http://' aj lomku z OnCreate, spájame priamo:
  //wr.URL := MojaServerIP + 'pass';
  //wr.URL := 'https://' + MojaServerIP + ':8080/pass';
  wr.URL := 'http://' + MojaServerIP + ':8080/pass';
//  wr.URL := MojaServerIP + '/pass';


  wr.PostData := '{"LOGIN":"'+eLogin.text+'",'+
                  '"PASS":"'+ePass.text+'"}';
// ShowMessage('Web sa pokúša pripojiť na adresu: ' + wr.URL);

  res := await(TJSXMLHttpRequest, wr.Perform);
  if res.responseText <> '' then
  begin
    // OPRAVA 2: V JavaScripte dekódujeme Base64 ultra-rýchlo cez zabudovanú funkciu atob
    asm
      try {
        a = atob(res.responseText);
      } catch(e) {
        a = '';
      }
    end;
    if a <> '' then
    begin
      JS := TJSON.Create;
      try
        JA := TJSONArray(JS.Parse(a));
        for i := 0 to JA.Count - 1 do
        begin
          JO := TJSONObject(JA.Items[i]);
          UId := strtoint(JO.GetJSONValue('UZIV_ID'));
          UMeno := JO.GetJSONValue('UZIV_MENO');
          UPriezvisko := JO.GetJSONValue('UZIV_PRIEZ');
          URola := strtoint(JO.GetJSONValue('UZIV_ROLA'));
          URolaPopis := JO.GetJSONValue('ROLA_ROLA');
        end;
      finally
        JS.Free;
      end;
    end;
  end;
  wr.Free;
  if UId <> 0 then
  begin
    PRISTPRAV[0] := URola;
    // Načítanie práv používateľa
    wr := THttpRequest.Create(nil);
    wr.Command := httpPOST;
    // OPRAVA 3: Správne spojenie pre práva
    //wr.URL := MojaServerIP + '/pravauser';
    wr.URL := 'http://' + MojaServerIP + ':8080/pravauser';

    wr.PostData := '{"FR_ROLA_ID":"'+inttostr(URola)+'"}';
    res := await(TJSXMLHttpRequest, wr.Perform);
    if res.responseText <> '' then
    begin
      asm
        try {
          a = atob(res.responseText);
        } catch(e) {
          a = '';
        }
      end;
      if a <> '' then
      begin
        JS := TJSON.Create;
        try
          JA := TJSONArray(JS.Parse(a));
          for i := 0 to JA.Count - 1 do
          begin
            JO := TJSONObject(JA.Items[i]);
            PRISTPRAV[strtoint(JO.GetJSONValue('FUNC_ID'))] := strtoint(JO.GetJSONValue('FR_ROLA'));
          end;
        finally
          JS.Free;
        end;
      end;
    end;
    wr.Free;
    // Spustenie hlavného formulára aplikácie
    Hlavny := TfHlavny.Create(Self);
    Hlavny.Popup := false;
    Hlavny.Border := fbSingle;
    await( TfHlavny, Hlavny.Load );
    await(TModalResult, Hlavny.Execute);
    Hlavny.free;
  end
  else
  begin
    // Vaša skvelá animácia trasenia tlačidla pri nesprávnom hesle
    for i := 1 to 3 do
    begin
      sbEnter.Left := sbEnter.Left - 5;
      asm await sleep(50); end;
      sbEnter.Left := sbEnter.Left + 10;
      asm await sleep(50); end;
      sbEnter.Left := sbEnter.Left - 5;
      asm await sleep(50); end;
    end;
  end;
end;


procedure TfHeslo.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  eLogin := TEdit.Create(Self);
  sbEnter := TSpeedButton.Create(Self);
  ePass := TEdit.Create(Self);
  WebClientConnection1 := TClientConnection.Create(Self);
  QUser := TClientDataSet.Create(Self);
  QUserKarta := TStringField.Create(Self);
  QUserMeno := TStringField.Create(Self);
  QUserPriezvisko := TStringField.Create(Self);
  QUserUZIV_ROLA := TIntegerField.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  eLogin.BeforeLoadDFMValues;
  sbEnter.BeforeLoadDFMValues;
  ePass.BeforeLoadDFMValues;
  WebClientConnection1.BeforeLoadDFMValues;
  QUser.BeforeLoadDFMValues;
  QUserKarta.BeforeLoadDFMValues;
  QUserMeno.BeforeLoadDFMValues;
  QUserPriezvisko.BeforeLoadDFMValues;
  QUserUZIV_ROLA.BeforeLoadDFMValues;
  try
    Name := 'fHeslo';
    Width := 792;
    Height := 654;
    Caption := 'T E S T O V N I C E';
    Color := 16763647;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := 16763647;
    Font.Height := -12;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 227;
    WebPanel1.Top := 174;
    WebPanel1.Width := 338;
    WebPanel1.Height := 306;
    WebPanel1.Center.Horizontal := True;
    WebPanel1.Center.Vertical := True;
    WebPanel1.Anchors := [];
    WebPanel1.ChildOrder := 5;
    WebPanel1.Color := 16763647;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 92;
    WebLabel1.Top := 120;
    WebLabel1.Width := 36;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Login :';
    WebLabel1.Color := 16763647;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlack;
    WebLabel1.Font.Height := -12;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.Transparent := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 72;
    WebLabel2.Top := 161;
    WebLabel2.Width := 56;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Password :';
    WebLabel2.Color := 16763647;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clBlack;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Segoe UI';
    WebLabel2.Font.Style := [];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.Transparent := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 10;
    WebLabel3.Top := 37;
    WebLabel3.Width := 318;
    WebLabel3.Height := 27;
    WebLabel3.Alignment := taCenter;
    WebLabel3.Anchors := [akTop];
    WebLabel3.AutoSize := False;
    WebLabel3.Caption := 'Testovnica';
    WebLabel3.Font.Charset := EASTEUROPE_CHARSET;
    WebLabel3.Font.Color := clBlack;
    WebLabel3.Font.Height := -24;
    WebLabel3.Font.Name := 'Times New Roman';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    eLogin.SetParentComponent(WebPanel1);
    eLogin.Name := 'eLogin';
    eLogin.Left := 140;
    eLogin.Top := 117;
    eLogin.Width := 121;
    eLogin.Height := 22;
    eLogin.AutoCompletion := acUserName;
    eLogin.Color := 15374108;
    eLogin.ElementClassName := 'form-control';
    eLogin.Font.Charset := DEFAULT_CHARSET;
    eLogin.Font.Color := clWhite;
    eLogin.Font.Height := -12;
    eLogin.Font.Name := 'Segoe UI';
    eLogin.Font.Style := [];
    eLogin.HeightPercent := 100.000000000000000000;
    eLogin.ParentFont := False;
    eLogin.Text := 'admin';
    eLogin.WidthPercent := 100.000000000000000000;
    SetEvent(eLogin, Self, 'OnKeyDown', 'eLoginKeyDown');
    sbEnter.SetParentComponent(WebPanel1);
    sbEnter.Name := 'sbEnter';
    sbEnter.Left := 58;
    sbEnter.Top := 240;
    sbEnter.Width := 223;
    sbEnter.Height := 41;
    sbEnter.Anchors := [akTop];
    sbEnter.Caption := 'L O G I N';
    sbEnter.Color := 16765066;
    sbEnter.ElementClassName := 'btn-primary';
    sbEnter.Font.Charset := DEFAULT_CHARSET;
    sbEnter.Font.Color := clBlack;
    sbEnter.Font.Height := -12;
    sbEnter.Font.Name := 'Segoe UI';
    sbEnter.Font.Style := [];
    sbEnter.HeightPercent := 100.000000000000000000;
    sbEnter.ParentFont := False;
    sbEnter.TabOrder := 2;
    sbEnter.WidthPercent := 100.000000000000000000;
    SetEvent(sbEnter, Self, 'OnClick', 'sbEnterClick');
    ePass.SetParentComponent(WebPanel1);
    ePass.Name := 'ePass';
    ePass.Left := 140;
    ePass.Top := 158;
    ePass.Width := 121;
    ePass.Height := 22;
    ePass.AutoCompletion := acCurrentPassword;
    ePass.ChildOrder := 2;
    ePass.Color := 15374108;
    ePass.ElementClassName := 'form-control';
    ePass.Font.Charset := DEFAULT_CHARSET;
    ePass.Font.Color := clWhite;
    ePass.Font.Height := -12;
    ePass.Font.Name := 'Segoe UI';
    ePass.Font.Style := [];
    ePass.HeightPercent := 100.000000000000000000;
    ePass.ParentFont := False;
    ePass.PasswordChar := 'x';
    ePass.WidthPercent := 100.000000000000000000;
    SetEvent(ePass, Self, 'OnKeyDown', 'ePassKeyDown');
    WebClientConnection1.SetParentComponent(Self);
    WebClientConnection1.Name := 'WebClientConnection1';
    WebClientConnection1.Active := False;
    WebClientConnection1.DataNode := 'ROW';
    WebClientConnection1.Delimiter := ';';
    WebClientConnection1.Password := 'passsss';
    WebClientConnection1.User := 'user';
    WebClientConnection1.URI := 'http://192.168.0.62:9998/info';
    WebClientConnection1.Left := 704;
    WebClientConnection1.Top := 40;
    QUser.SetParentComponent(Self);
    QUser.Name := 'QUser';
    QUser.Connection := WebClientConnection1;
    QUser.Left := 704;
    QUser.Top := 104;
    QUserKarta.SetParentComponent(QUser);
    QUserKarta.Name := 'QUserKarta';
    QUserKarta.FieldName := 'UZIV_ID';
    QUserKarta.Size := 256;
    QUserMeno.SetParentComponent(QUser);
    QUserMeno.Name := 'QUserMeno';
    QUserMeno.FieldName := 'UZIV_MENO';
    QUserMeno.Size := 256;
    QUserPriezvisko.SetParentComponent(QUser);
    QUserPriezvisko.Name := 'QUserPriezvisko';
    QUserPriezvisko.FieldName := 'UZIV_PRIEZ';
    QUserPriezvisko.Size := 256;
    QUserUZIV_ROLA.SetParentComponent(QUser);
    QUserUZIV_ROLA.Name := 'QUserUZIV_ROLA';
    QUserUZIV_ROLA.FieldName := 'UZIV_ROLA';
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    eLogin.AfterLoadDFMValues;
    sbEnter.AfterLoadDFMValues;
    ePass.AfterLoadDFMValues;
    WebClientConnection1.AfterLoadDFMValues;
    QUser.AfterLoadDFMValues;
    QUserKarta.AfterLoadDFMValues;
    QUserMeno.AfterLoadDFMValues;
    QUserPriezvisko.AfterLoadDFMValues;
    QUserUZIV_ROLA.AfterLoadDFMValues;
  end;
end;

end.
